const getActionInitialData = (actionType) => {
  const initialData = {}

  switch (actionType) {
    case 'SUPPORT':
    case 'CANCEL':
      initialData.actionProperties = {
        intentId: actionType,
      }
      break
    case 'DATA_ENTRY':
      initialData.actionProperties = {
        type: 'string',
        name: ''
      }
      break
    case 'dataEntry':
      initialData.eventData = {
        dataType: 'string',
      }
      break
    default:
      break
  }

  return initialData
}

export default getActionInitialData
